<!-- DX's dx-modal always renders a header close, so (closed) must tear down the outer modal even with showCloseButton=false -->
<chd-dialog [disableClose]="true" [label]="title" [showCloseButton]="false" [visible]="true" (closed)="closed.emit()">
  <chd-text>{{ content }}</chd-text>
  @if (button; as alertButton) {
    <chd-button chd-dialog-actions [label]="alertButton.label" (clicked)="alertButton.action($event)" />
  }
</chd-dialog>
